import IntlMessages from '@crema/utility/IntlMessages'
import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'
import React, { ReactNode } from 'react'

interface FormBlockProps {
    titleId: string,
    action?: ReactNode
}
const FormBlock: React.FC<FormBlockProps> = ({ titleId, children, action }) => {
    return (
        <Box mb={8}>
            <Box style={{ display: 'flex', justifyContent: 'space-between',alignItems:'center' }}>
                <Box component="h3" fontSize="1rem" mb={4}>
                    <IntlMessages id={titleId} />
                </Box>
                {action}
            </Box>

            <Divider style={{ marginBottom: "1.5rem" }} />
            {children}
        </Box>
    )
}

export default FormBlock